import React, { useState, useEffect } from 'react';
import SimpleHome from './SimpleHome';
import LegacyHome from './LegacyHome';

export const HomeMenu = () => {
  const [useSimpleHome, setUseSimpleHome] = useState(() => {
    const saved = localStorage.getItem('clutterlogix_home_mode');
    // Default new users (no saved preference) to the simple dashboard.
    return saved ? saved === 'simple' : true;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const saved = localStorage.getItem('clutterlogix_home_mode');
      setUseSimpleHome(saved ? saved === 'simple' : true);
    };
    
    window.addEventListener('storage', handleStorageChange);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        handleStorageChange();
      }
    });
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  return useSimpleHome ? <SimpleHome /> : <LegacyHome />;
};
